/**
 * 问卷管理 相关菜单配置
 *
 */

// import Layout from "../components/layout";
import { lazyLoad } from "@/utils/lazyLoad";
const caseRoute = [
  {
    // component: Layout,
    component: lazyLoad,
    path: "questionnaire-manage",
    meta: {
      title: "问卷管理",
      icon: "icon-questionnaire",
    },
    children: [
      {
        path: "/questionnaire/manage",
        name: "QuestionnaireManage",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/pages/questionnaireManage/questionnaireList"
          ),
        meta: {
          title: "问卷列表",
          icon: "home",
        },
      },
    ],
  },
];
export default caseRoute;
